export const ESTIMATE_LIST_LOADING_MIN_HEIGHT = "400px";

export const resolveEstimateListRows = <T>(rows: T[], loading: boolean): T[] =>
  loading ? [] : rows;
